export const FI_VERSION = '7.02.43';